// main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles/App.css';

// Clear invalid localStorage data on startup
const clearInvalidStorage = () => {
  const token = localStorage.getItem('dev_token');
  const user = localStorage.getItem('dev_user');
  
  // Check if token is 'undefined' or 'null'
  if (token === 'undefined' || token === 'null') {
    localStorage.removeItem('dev_token');
  }
  
  // Check if user is 'undefined', 'null', or not valid JSON
  if (user === 'undefined' || user === 'null') {
    localStorage.removeItem('dev_user');
  } else if (user) {
    try {
      JSON.parse(user);
    } catch {
      localStorage.removeItem('dev_user');
    }
  }
};

clearInvalidStorage();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);